import { usePrefersReducedMotion } from "../contexts/prefersReducedMotion/prefersReducedMotion.hook";
import { useEffect, useRef, useState } from "react";

interface UseVideoPlaybackOptions {
  isActive: boolean;
  maxRetries?: number;
}

export const useVideoPlayback = ({
  isActive,
  maxRetries = 2,
}: UseVideoPlaybackOptions) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [forceFallback, setForceFallback] = useState(false);
  const { prefersReducedMotion } = usePrefersReducedMotion();
  const playbackFailures = useRef(0);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || prefersReducedMotion || forceFallback) return;

    const tryPlay = () => {
      if (video.readyState >= 3) {
        requestAnimationFrame(() => {
          video.play().catch((err) => {
            console.warn("Video autoplay failed:", err);
            playbackFailures.current += 1;

            if (playbackFailures.current >= maxRetries) {
              setForceFallback(true);
              return;
            }

            video.pause();
            video.currentTime = 0;
            video.load();
            setTimeout(tryPlay, 100);
          });
        });
      } else {
        setTimeout(tryPlay, 50);
      }
    };

    if (isActive) {
      setForceFallback(false);
      playbackFailures.current = 0;
      tryPlay();
    } else {
      video.pause();
    }
  }, [isActive, prefersReducedMotion, forceFallback, maxRetries]);

  return { forceFallback, videoRef };
};
